import type { ReactionsOnMailListItemContainerProps } from "./components/ReactionsOnMailListItemContainer";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "ReactionsMailList"*/ "./lazyIndex"), { name: "ReactionsMailList" });

export const ReactionsOnMailListItemContainer: LazyComponent<ReactionsOnMailListItemContainerProps, unknown, void> = createLazyComponent(lazyModule, m => m.ReactionsOnMailListItemContainer);
